<!-- Header do diálogo -->
<div matDialogTitle class="dialog-header-row">
  <mat-icon class="dialog-title-icon">storage</mat-icon>
  <span class="dialog-title-text" [title]="data.title">{{ data.title }}</span>
  <button mat-icon-button class="dialog-close-btn" (click)="close()" aria-label="Fechar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content-padded">
  <form [formGroup]="produtoForm">

    <!-- Resumo de movimentações -->
    <ng-container *ngIf="detailsMovto && detailsMovto?.numero_lcto > 0; else noMovto">
      <div class="stat-bar">
        <div class="stat-item">
          <mat-icon class="stat-icon primary-color">receipt_long</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Lctos</span>
            <span class="stat-value">{{ detailsMovto.numero_lcto }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon accent-color">event</mat-icon>
          <div class="stat-content">
            <span class="stat-label">1º Lcto</span>
            <span class="stat-value">{{ detailsMovto.data_primeiro_lcto | date: "dd/MM/yy" }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon success-color">event_available</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Último Lcto</span>
            <span class="stat-value">{{ detailsMovto.data_ultimo_lcto | date: "dd/MM/yy" }}</span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noMovto>
      <div class="no-movto-banner">
        <mat-icon>info_outline</mat-icon>
        <span>Nenhum lançamento registrado para este produto</span>
      </div>
    </ng-template>

    <!-- Filtros -->
    <div class="filter-row">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Data Inicial</mat-label>
        <input matInput type="date" [(ngModel)]="dataInicial"
          (change)="reloadPageMovto()" [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Data Final</mat-label>
        <input matInput type="date" [(ngModel)]="dataFinal"
          (change)="reloadPageMovto()" [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>
      <button mat-raised-button color="primary" class="filter-btn" (click)="reloadPageMovto()">
        <mat-icon>refresh</mat-icon>
        <span class="hide-on-mobile">Atualizar</span>
      </button>
    </div>

    <!-- Mobile: lista de cards -->
    <ng-container *ngIf="layoutConf?.isMobile; else desktopTable">
      <ng-container *ngIf="movtos && movtos.length > 0; else emptyState">
        <div class="movto-card-list">
          <mat-card class="user-card p-0" *ngFor="let movto of movtos">
            <mat-card-title>
              <div class="mobile-card-title">
                <div class="mobile-card-title-actions">
                  <span class="movto-natureza-badge"
                        [class.badge-entrada]="movto?.natureza !== 'S'"
                        [class.badge-saida]="movto?.natureza === 'S'">
                    <mat-icon>{{ movto?.natureza === 'S' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                    {{ movto?.natureza === 'S' ? 'Saída' : 'Entrada' }}
                  </span>
                  <span class="mobile-card-date">{{ movto?.dataMovto | date: 'dd/MM/yy' }}</span>
                  <button mat-icon-button
                          (click)="$event.preventDefault(); openLcto(movto?.lcto?.controle)"
                          matTooltip="Abrir lançamento">
                    <mat-icon color="primary">open_in_new</mat-icon>
                  </button>
                  <button mat-icon-button
                          (click)="$event.preventDefault(); consistir(movto)"
                          matTooltip="Consistir lançamentos">
                    <mat-icon color="accent">autorenew</mat-icon>
                  </button>
                </div>
                <div class="mobile-card-title-description">
                  {{ (movto?.lcto?.serie?.codigo ? movto.lcto.serie.codigo + '-' : '') +
                     (movto?.lcto?.numeroDocto?.toString().padStart(9, '0') || '') }}
                </div>
              </div>
              <mat-divider></mat-divider>
            </mat-card-title>
            <mat-card-content>
              <div class="user-details">
                <table class="mat-table" style="text-align: left; width: 100%;">
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Controle:</td>
                    <td class="mat-cell">{{ movto?.lcto?.controle?.toString().padStart(10, '0') }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Cadastro:</td>
                    <td class="mat-cell overflow-cell">{{ movto?.cadastro?.codigo + ' - ' + movto?.cadastro?.razaoSocial }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Transação:</td>
                    <td class="mat-cell overflow-cell">{{ movto?.fatTransacao?.codigo + ' - ' + movto?.fatTransacao?.descricao }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Filial:</td>
                    <td class="mat-cell">{{ filialLabel(movto) }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Qtde:</td>
                    <td class="mat-cell">{{ movto?.qtde | number:'1.2-4' }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Val. Unit.:</td>
                    <td class="mat-cell">{{ movto?.valorUnitario | number:'1.2-2' }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Val. Total:</td>
                    <td class="mat-cell">{{ movto?.valorTotal | number:'1.2-2' }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Saldo:</td>
                    <td class="mat-cell"><strong>{{ movto?.saldo | number:'1.2-4' }}</strong></td>
                  </tr>
                  <tr class="mat-row" *ngIf="podeVerCusto">
                    <td class="mat-cell label-cell">Custo Médio:</td>
                    <td class="mat-cell">{{ movto?.custoMedio | number:'1.2-4' }}</td>
                  </tr>
                  <tr class="mat-row" *ngIf="podeVerCusto">
                    <td class="mat-cell label-cell">Custo NF:</td>
                    <td class="mat-cell">{{ movto?.custoNf | number:'1.2-4' }}</td>
                  </tr>
                  <tr class="mat-row" *ngIf="podeVerCusto">
                    <td class="mat-cell label-cell">C. Reposição:</td>
                    <td class="mat-cell">{{ movto?.custoDigitado | number:'1.2-4' }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Atualiza Est.:</td>
                    <td class="mat-cell">{{ simNaoOuBranco(movto?.atualizaEstoque) }}</td>
                  </tr>
                  <tr class="mat-row">
                    <td class="mat-cell label-cell">Total Lcto:</td>
                    <td class="mat-cell"><strong>{{ movto?.lcto?.valortotalDocto | currency: 'BRL' }}</strong></td>
                  </tr>
                </table>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
      <ng-template #emptyState>
        <div class="empty-state">
          <mat-icon>inbox</mat-icon>
          <p>Nenhuma movimentação encontrada para o período</p>
        </div>
      </ng-template>
      <mat-paginator
        #paginator
        [length]="length"
        [showFirstLastButtons]="true"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = setPageSizeOptions($event)">
      </mat-paginator>
    </ng-container>

    <!-- Desktop: tabela (mesmas colunas da aba "Movimentaçao" do cadastro de produto do desktop) -->
    <ng-template #desktopTable>
      <ngx-datatable
        class="material movto-table"
        [rows]="movtos"
        [headerHeight]="48"
        [footerHeight]="56"
        [scrollbarH]="true"
        [columnMode]="'force'"
        [messages]="{ emptyMessage: 'Nenhuma movimentação encontrada p/ o período' }"
        [limit]="pageSize"
        [rowHeight]="48">
        <ngx-datatable-column name="#" [width]="45" [canAutoResize]="false" [frozenLeft]="true"
                              [sortable]="false" [draggable]="false" [resizeable]="false">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Opções" [width]="105" [canAutoResize]="false" [frozenLeft]="true"
                              [sortable]="false" [draggable]="false" [resizeable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button color="primary" matTooltip="Abrir lançamento"
                    (click)="$event.preventDefault(); openLcto(row?.lcto?.controle)">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <button mat-icon-button color="accent" matTooltip="Consistir lançamentos"
                    (click)="$event.preventDefault(); consistir(row)">
              <mat-icon>autorenew</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Data" [width]="95" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.dataMovto | date: "dd/MM/yy" }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Controle" [width]="105" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.lcto?.controle?.toString().padStart(10, "0") }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Nat" [width]="80" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span [class.saida-text]="row?.natureza === 'S'"
                  [class.entrada-text]="row?.natureza !== 'S'">
              {{ row?.natureza === "S" ? "Saída" : "Entrada" }}
            </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Documento" [width]="120" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ (row?.lcto?.serie?.codigo ? row.lcto.serie.codigo + '-' : '') +
               row?.lcto?.numeroDocto?.toString().padStart(9, "0") }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Nome Cadastro" [width]="260" [minWidth]="180" [flexGrow]="2">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span [matTooltip]="row?.cadastro?.codigo + '-' + row?.cadastro?.razaoSocial">
              {{ row?.cadastro?.codigo + "-" + row?.cadastro?.razaoSocial }}
            </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Filial" [width]="85" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ filialLabel(row) }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Transação" [width]="220" [minWidth]="180" [flexGrow]="2">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span [matTooltip]="row?.fatTransacao?.codigo + '-' + row?.fatTransacao?.descricao">
              {{ row?.fatTransacao?.codigo + "-" + row?.fatTransacao?.descricao }}
            </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Qtde" [width]="85" [canAutoResize]="false">
          <ng-template ngx-datatable-header-template><div class="text-right">Qtde</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.qtde | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Val. Unit." [width]="95" [canAutoResize]="false">
          <ng-template ngx-datatable-header-template><div class="text-right">Val. Unit.</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.valorUnitario | number: "1.2-2" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Val. Total" [width]="100" [canAutoResize]="false">
          <ng-template ngx-datatable-header-template><div class="text-right">Val. Total</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.valorTotal | number: "1.2-2" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Saldo" [width]="95" [canAutoResize]="false">
          <ng-template ngx-datatable-header-template><div class="text-right">Saldo</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right"><strong>{{ row?.saldo | number: "1.2-4" }}</strong></div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Total Lcto" [width]="120" [canAutoResize]="false">
          <ng-template ngx-datatable-header-template><div class="text-right">Total Lcto</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.lcto?.valortotalDocto | currency: "BRL" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Devolução" [width]="95" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ simNaoOuBranco(row?.devolucao) }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Atualiza Estoque" [width]="115" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ simNaoOuBranco(row?.atualizaEstoque) }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Atualiza Custo Médio" [width]="130" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ simNaoOuBranco(row?.alteraCustoMedio) }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Atualiza Custo Ult.Compra" [width]="155" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ simNaoOuBranco(row?.alteraCustoUltimaCompra) }}
          </ng-template>
        </ngx-datatable-column>

        <!-- Colunas de custo: só p/ quem tem permissão "Editar Produto" (igual ao desktop) -->
        <ngx-datatable-column name="Custo Inventário" [width]="115" [canAutoResize]="false" *ngIf="podeVerCusto">
          <ng-template ngx-datatable-header-template><div class="text-right">Custo Inventário</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.custoInventario | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Custo Inv.Total" [width]="115" [canAutoResize]="false" *ngIf="podeVerCusto">
          <ng-template ngx-datatable-header-template><div class="text-right">Custo Inv.Total</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.custoInventarioTotal | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Custo NF" [width]="100" [canAutoResize]="false" *ngIf="podeVerCusto">
          <ng-template ngx-datatable-header-template><div class="text-right">Custo NF</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.custoNf | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Custo Reposição" [width]="115" [canAutoResize]="false" *ngIf="podeVerCusto">
          <ng-template ngx-datatable-header-template><div class="text-right">Custo Reposição</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.custoDigitado | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Custo Real" [width]="100" [canAutoResize]="false" *ngIf="podeVerCusto">
          <ng-template ngx-datatable-header-template><div class="text-right">Custo Real</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.custoReal | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Custo Médio" [width]="105" [canAutoResize]="false" *ngIf="podeVerCusto">
          <ng-template ngx-datatable-header-template><div class="text-right">Custo Médio</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.custoMedio | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Custo Médio Total" [width]="125" [canAutoResize]="false" *ngIf="podeVerCusto">
          <ng-template ngx-datatable-header-template><div class="text-right">Custo Médio Total</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.custoMedioTotal | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Saldo2" [width]="95" [canAutoResize]="false">
          <ng-template ngx-datatable-header-template><div class="text-right">Saldo2</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.saldo2 | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Saldo Inventário" [width]="115" [canAutoResize]="false">
          <ng-template ngx-datatable-header-template><div class="text-right">Saldo Inventário</div></ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="text-right">{{ row?.saldoInventario | number: "1.2-4" }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template>
            <mat-paginator
              #paginator
              [length]="length"
              [showFirstLastButtons]="true"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              (page)="pageEvent = setPageSizeOptions($event)">
            </mat-paginator>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </ng-template>

  </form>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>
    <span class="hide-on-mobile">{{ "CLOSE" | translate }}</span>
  </button>
</mat-dialog-actions>